// // 设置cookie,增加到vue实例方便全局调用
// export const setCookie = (name, value, expiredays) => {
//   let exdate = new Date()
//   exdate.setDate(exdate.getDate() + expiredays)
//   document.cookie = name + '=' + escape(value) + ((expiredays == null) ? '' : ';expires=' + exdate.toGMTString())
// }

// // 获取cookie、
// export const getCookie = name => {
//   let getCookie = document.cookie.replace(/[ ]/g, '')
//   let arrCookie = getCookie.split(';')
//   let tips
//   for (let i = 0; i < arrCookie.length; i++) {
//     const arr = arrCookie[i].split('=')
//     if (name === arr[0]) {
//       tips = arr[1]
//       break
//     }
//   }
//   // console.log(tips)
//   return unescape(tips)
// }

// // 删除cookie
// export const delCookie = name => {
//   let exp = new Date()
//   exp.setTime(exp.getTime() - 1)
//   let cval = getCookie(name)
//   if (cval != null) {
//     document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString()
//   }
// }

//设置cookie,增加到vue实例方便全局调用
export const setCookie = (c_name, value, expiredays) => {
  var exdate = new Date();
  exdate.setDate(exdate.getDate() + expiredays);
  document.cookie =
    c_name +
    "=" +
    escape(value) +
    (expiredays == null ? "" : ";expires=" + exdate.toGMTString());
};

//获取cookie、
export const getCookie = name => {
  var arr = document.cookie.match(new RegExp("(^| )" + name + "=([^;]*)(;|$)"));
  if (arr != null) {
    return unescape(arr[2]);
  } else {
    return null;
  }
};
//删除cookie
export const delCookie = name => {
  var exp = new Date();
  exp.setTime(exp.getTime() - 1);
  var cval = getCookie(name);
  if (cval != null)
    document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
};
